import { action, observable, ObservableMap } from 'mobx';

interface ILearningCenterItem {
    id: number;
    title: string;
    intro?: string;
    steps?: Array<any>;
    video_embed: string;
    duration: string;
}

interface ILearningCenterItems {
    items: Array<ILearningCenterItem>;
}


export class LearningCenterStore {

    constructor() {
        this.getLearningCenterItems();
    }

    private tries = 0;
    private maxTries = 8;

    @observable
    private _allItemsById = new ObservableMap<string, ILearningCenterItem>();

    @observable
    public items: Array<ILearningCenterItem> = [];

    public getItemById(id: number): ILearningCenterItem {
        let foundItem = this.items.find((item) => item.id === id);
        return foundItem!;
    }

    @action
    public async getLearningCenterItems() {

        this.tries ++;

        const url = 'https://learn.tightknit.com/wp-json/wp/v2/learning_center_item?orderby=menu_order&order=asc&per_page=100';
        const res = await fetch(url);
        let items = await res.json();

        if (items && items.length) {
            items.map((item: any) => {
                let parsedItem = {
                    id: item.id,
                    title: item.title.rendered,
                    intro: item.acf.intro,
                    steps: item.acf.steps,
                    video_embed: item.acf.video_embed_code,
                    duration: item.acf.duration,
                };
                this.items.push(parsedItem);
                const allItemsById = this.items.reduce((map, LCItem) =>
                    map.set(LCItem.id.toString(), LCItem), new ObservableMap<string, ILearningCenterItem>()
                );

                this._allItemsById = allItemsById;
            });
        } else {
            if (this.tries < this.maxTries) {
                window.setTimeout(() => {
                    this.getLearningCenterItems();
                }, 500);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/_stores/LearningCenterStore.ts